import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import config from './config.ts';
import { ai, getAppInsights } from './infrastructure/Logging/TelemetryService';
import { setSpanishAsDefaultLanguageForMoment } from './application/Common/TimeUtilityConfigSpanish.ts';
import { StrictMode } from 'react';
import { ConfigProvider } from 'antd';
import es from 'antd/locale/es_ES';
import './styles/index.css'
import './tenantMatrix/themeStyleImports.ts';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { StoreContext } from './store/StoreContext';

setSpanishAsDefaultLanguageForMoment();

// Initialize Application Insights
if (config.environment !== 'dev' && config.appInsightsConnectionString) {
    ai.initialize();
}

// Global error and promise rejection handlers to avoid silent blanks
window.addEventListener('error', (ev) => {
  try {
    const app = getAppInsights();
    app?.trackException({ exception: ev.error ?? new Error(String(ev.message)) });
    app?.trackEvent({ name: 'global-error', properties: { filename: String((ev as any).filename || ''), lineno: String((ev as any).lineno || '') } });
  } catch {}
});

window.addEventListener('unhandledrejection', (ev) => {
  try {
    const app = getAppInsights();
    const reason = (ev as PromiseRejectionEvent).reason;
    app?.trackException({ exception: reason instanceof Error ? reason : new Error(String(reason)) });
    app?.trackEvent({ name: 'unhandled-rejection' });
  } catch {}
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
     <StoreContext>
      <ConfigProvider locale={es}>
        <MantineProvider>
          <App />
        </MantineProvider>
      </ConfigProvider>
    </StoreContext>
  </StrictMode>,
)
